import { render, staticRenderFns } from "./LandingAgeGrid.vue?vue&type=template&id=1f6db55e&scoped=true"
import script from "./LandingAgeGrid.vue?vue&type=script&lang=js"
export * from "./LandingAgeGrid.vue?vue&type=script&lang=js"
import style0 from "./LandingAgeGrid.vue?vue&type=style&index=0&id=1f6db55e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6db55e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f6db55e')) {
      api.createRecord('1f6db55e', component.options)
    } else {
      api.reload('1f6db55e', component.options)
    }
    module.hot.accept("./LandingAgeGrid.vue?vue&type=template&id=1f6db55e&scoped=true", function () {
      api.rerender('1f6db55e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Landing/components/LandingAgeGrid.vue"
export default component.exports